import React, { useEffect, useState, useCallback } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { addMinutes } from 'date-fns';

import { Button, Modal, selectors, orderItemUtils } from '@fernleaf/util';
import CustomerList from './CustomerList/CustomerList';
import PaymentButtons from './PaymentButtons/PaymentButtons';
import SplitPaymentDialog from './SplitPaymentDialog/SplitPaymentDialog';

import apiGetSquareIds from '../api/getSquareIds';
import apiCreateOrUpdateOrder from '../api/createOrUpdateOrder';
import apiPayOrder from '../api/payOrder';
import apiReportSystemError from '../api/reportSystemError';

import { closingTime } from '../PickupDate/PickupDate';
import { 
    getCustomer, getCart, getCartNotes, getPickupDate, getCalendar, getOrderToPay, getPartialPaymentItem,
    // getDiscounts,
    setCustomer, getSystemControls,
    returnToAdminAction
} from '../store/redux';

import { priceUtils, actions } from '@fernleaf/util';
import CartTotals from '../Cart/CartTotals/CartTotals';
import classes from './Checkout.module.css';
import { format } from 'date-fns';
const updateUser = actions.login;

const EMAIL = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
const PHONE = /^(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;

// const getDiscountOptions = ( discounts ) => {
//     // Can't get selector to work, for now we only support a single fixed amount discount
//     // at the order level - applied to the first item big enough, or the largest item if none.
//     let options = null;
//     if ( discounts ) options = discounts.map( discount => 
//         ( { value: discount.id, 
//             label: `${ discount.discount_data.name } $${
//                     ( discount.discount_data.amount_money.amount / 100 ).toFixed( 2 ) }`,
//             amount: discount.discount_data.amount_money.amount 
//         } )
//     );
//     if ( options && options.length !== 1 ) {
//         options = null;
//     }
//     return options;
// }

const isPaid = ( order ) => order && order.squarePaymentId && order.squarePaymentId !== 'HOLD';

const nameHint = ( inputName ) => {
    if ( inputName && inputName.trim().length > 0 &&
         ( inputName.trim().indexOf( ' ' ) === -1 ) ) {
        return <div>
            <strong>Please enter first and last name</strong>
        </div>
    }
}

const emailHint = ( name, phone, email ) => {
    if ( name.trim().length > 0 && phone.match( PHONE ) && email.trim().length === 0 ) {
        return <div>
            <strong>Please ask for email</strong>
        </div>
    }
}

const Checkout = ( { history } ) => {
    const dispatch = useDispatch();
    const systemControls = useSelector( getSystemControls );
    const user = useSelector( selectors.getUser );
    const customer = useSelector( getCustomer );
    const cart = useSelector( getCart );
    // const discounts = useSelector( getDiscounts );
    // const discountOptions = getDiscountOptions( discounts );
    const cartNotes = useSelector( getCartNotes );
    const pickupDate = useSelector( getPickupDate );
    const calendar = useSelector( getCalendar );
    const orderToPay = useSelector( getOrderToPay );
    const partialPaymentItem = useSelector( getPartialPaymentItem );
    const [ orderLoaded, setOrderLoaded ] = useState( false );
    // const [ showDiscountPopup, setShowDiscountPopup ] = useState( false );
    // const [ selectedDiscount, setSelectedDiscount ] = useState();
    const [ showTaxCert, setShowTaxCert ] = useState( false );
    const [ tempTaxCert, setTempTaxCert ] = useState();
    const [ taxCert, setTaxCert ] = useState();
    const [ taxCertInputRef ] = useState( React.createRef() );
    const [ blockInput, setBlockInput ] = useState( false );
    const [ squareIds, setSquareIds ] = useState();
    const [ name, setName ] = useState( '' );
    const [ email, setEmail ] = useState( '' );
    const [ phone, setPhone ] = useState( '' );
    const [ pickupName, setPickupName ] = useState( '' );
    const [ pickupPhone, setPickupPhone ] = useState( '' );
    const [ order, setOrder ] = useState();
    const [ showHoldConfirm, setShowHoldConfirm ] = useState( false );
    const [ showSplitPaymentDialog, setShowSplitPaymentDialog ] = useState( false );
    const [ showTip, setShowTip ] = useState( false );
    const [ tipAmount, setTipAmount ] = useState();
    const [ tempTipAmount, setTempTipAmount ] = useState( 0 );
    const [ tipInputRef ] = useState( React.createRef() );
    const [ messages, setMessages ] = useState( [] );
    const [ userError, setUserError ] = useState();
    const [ orderingForPickup, setOrderingForPickup ] = useState( false );
    const [ outOfStock, setOutOfStock ] = useState( null );
    const [ noAmount, setNoAmount ] = useState( false );

    const orderTotal = priceUtils.orderPaymentTotal( cart, taxCert );

    useEffect ( () => {
        if ( ! squareIds ) {
            apiGetSquareIds( setSquareIds, dispatch );
        }
    }, [ squareIds, setSquareIds, dispatch ] );

    useEffect ( () => {
        const isForPickup = pickupDate && pickupDate > addMinutes( new Date(), 15 );
        if ( isForPickup !== orderingForPickup ) {
            setOrderingForPickup( isForPickup );
        }
    }, [ pickupDate, orderingForPickup ] );

    useEffect ( () => {
        if ( ( user.isAdmin && ! customer ) || ! systemControls ) {
            return; // Wait for control objects to load from the database - only initialize customer once
        }

        let person = {};

        if ( ! user.isAdmin ) {
            person = user;

        } else {
            person = customer;

        }

        setName( person.name || '' );
        setEmail( person.email || '' );
        setPhone( person.phone || '' );

    }, [ user, customer, systemControls ] );

    useEffect ( () => {
        if ( orderToPay && ! order ) {
            setOrder( orderToPay );
        }
    }, [ orderToPay, order ] );

    useEffect ( () => {
        if ( order && ! orderLoaded ) {
            setPickupName( order.pickupName || '' );
            setPickupPhone( order.pickupPhone || '' );
            setTaxCert( order.taxCert );
            setOrderLoaded( true );
        }
    }, [ order, orderLoaded ] );

    useEffect ( () => {
        if ( user.isAdmin && ! customer ) {
            return; // Wait for control objects to load from the database
        }

        // if ( order && isPaid( order ) ) {
        //     setMessages( [ 'THIS ORDER IS ALREADY PAID - CHECK IN SQUARE' ] );
        //     return;
        // }

        const messages = [];

        if ( ! orderingForPickup ) {
            return;
        }

        if ( name.trim().length === 0 ) {
            messages.push( 'Contact name is required.' );
        }
        
        if ( phone.trim().length === 0 ) {
            messages.push( 'Contact phone is required.' );
        } else if ( ! phone.match( PHONE ) ) {
            messages.push( 'Invalid contact phone number.' );
        }

        if ( email.trim().length > 0 && ! email.match( EMAIL ) ) {
            messages.push( 'Invalid email address.' );
        }

        if ( pickupPhone.trim().length > 0 && ! pickupPhone.match( PHONE ) ) {
            messages.push( 'Invalid pickup phone number.' );
        }

        setMessages( messages );
    }, [ name, email, phone, pickupName, pickupPhone, customer, orderingForPickup, order,
         pickupDate, user ] 
    );

    useEffect ( () => {
        if ( showTaxCert && taxCertInputRef && taxCertInputRef.current ) {
            taxCertInputRef.current.focus();
        }
    }, [ showTaxCert, taxCertInputRef ] );

    useEffect ( () => {
        if ( showTip ) {
            tipInputRef.current.focus();
        }
    }, [ showTip, tipInputRef ] );

    const returnToCart = useCallback( (e) => {
        if ( e ) e.stopPropagation();
        history.push( '/cart' );
    }, [ history ] );

    useEffect ( () => {
        const orderTotal = priceUtils.orderPaymentTotal( cart, taxCert );
        if ( orderTotal === 0 && user.id && ! user.isAdmin ) {
            history.push( '/orders' ); // Show user their orders
        }
    }, [ cart, taxCert, user, history ] );

    // const showDiscounts = useCallback( (e) => {
    //     e.stopPropagation();
    //     setShowDiscountPopup( true );
    // }, [ setShowDiscountPopup ] );
    // const addDiscount = useCallback( (e) => {
    //     // For now supporting only a single order level discount
    //     setSelectedDiscount( discountOptions[ 0 ] );
    //     setShowDiscountPopup( false );
    //     e.stopPropagation();
    // }, [ discountOptions, setSelectedDiscount, setShowDiscountPopup ] );
    // const removeDiscount = useCallback( (e) => {
    //     setSelectedDiscount( null );
    //     setShowDiscountPopup( false );
    //     e.stopPropagation();
    // }, [ setSelectedDiscount, setShowDiscountPopup ] );
    // const hideDiscounts = useCallback( (e) => {
    //     e.stopPropagation();
    //     setShowDiscountPopup( false );
    // }, [ setShowDiscountPopup ] );

    const selectCustomer = useCallback( customer =>  dispatch( setCustomer( customer ) ), [ dispatch ] );

    const showTaxCertInput = useCallback( (e) => {
        e.stopPropagation();
        setShowTaxCert( true );
    }, [ setShowTaxCert ] );

    const hideTaxCertInput = useCallback( (e) => {
        e.stopPropagation();
        setShowTaxCert( false );
    }, [ setShowTaxCert ] );

    const processTaxCertEntry = useCallback( (e) => {
        setTempTaxCert( ( e.target.value || '' ).trim() || null );
    }, [ setTempTaxCert ] );

    const acceptTaxCert = useCallback( (e) => {
        e.stopPropagation();
        setTaxCert( tempTaxCert );
        setShowTaxCert( false );
    }, [ setTaxCert, setShowTaxCert, tempTaxCert ] );

    const removeTaxCert = useCallback( (e) => {
        e.stopPropagation();
        setTaxCert( null );
        setShowTaxCert( false );
    }, [ setTaxCert, setShowTaxCert ] );

    const showTipInput = useCallback( (e) => {
        e.stopPropagation();
        setTempTipAmount( tipAmount || 0 );
        setShowTip( true );
    }, [ setTempTipAmount, setShowTip, tipAmount ] );

    const hideTipInput = useCallback( (e) => {
        e.stopPropagation();
        setShowTip( false );
    }, [ setShowTip ] );

    const processTipEntry = useCallback( (e) => {
        orderItemUtils.processDollarEntry( e, tempTipAmount, setTempTipAmount );
    }, [ tempTipAmount, setTempTipAmount ] );

    const acceptTipChanges = useCallback( (e) => {
        e.stopPropagation();
        setTipAmount( tempTipAmount || null );
        setShowTip( false );
    }, [ setTipAmount, setShowTip, tempTipAmount ] );

    const removeTip = useCallback( (e) => {
        e.stopPropagation();
        setTipAmount( null );
        setShowTip( false );
    }, [ setTipAmount, setShowTip ] );

    const createOrUpdateOrder = useCallback( ( e, nextAction, errorAction ) => {
        e.stopPropagation();

        const processResult = ( result ) => {
            if ( result.userError ) {
                setUserError( 
                    result.userError === 'phone' ?
                        'The phone number is not unique, please specify an email address.' :
                    result.userError === 'email' ?
                        'The specified email belongs to another customer.' :
                        `Unknown error from server: ${ result.userError } - contact support`
                );
                setBlockInput( false );
                errorAction && errorAction( result );
                return;
            }
            setUserError( null );
            if ( ! result.order ) {
                console.log( 'Unexpected reply from create order:', result );
                apiReportSystemError( 'Error creating order', result );
                alert( 'The order could not be created. Please try again.' );
            } else {
                const order = result.order;
                setOrder( order );
                setOutOfStock( result.outOfStock );
                if ( order.overrideStockLevel && ! orderToPay ) {
                    alert( 
                        'This order did an override on the stock levels.\n' +
                        '\n' +
                        'YOU MUST VERIFY STOCK LEVELS FOR ALL ITEMS ON THIS ORDER.'
                    );
                }
                
                if ( ! result.outOfStock ) {
                    if ( customer ) {
                        if ( ! systemControls.inPerson && ! systemControls.storeOrder ) {
                            dispatch( setCustomer( result.user ) );
                        }
                    } else {
                        dispatch( updateUser( result.user ) );
                    }
                }
                nextAction && nextAction( order );
            }
            setBlockInput( false );
        };

        if ( ! order || ! isPaid( order ) ) {
            setBlockInput( true );
            apiCreateOrUpdateOrder(
                { 
                    user: customer || user, name, email, phone,
                    orderedBy: customer && user.name,
                    taxCert, 
                    adminUser: user  
                },
                { pickupName, pickupPhone },
                pickupDate, cart, cartNotes, orderTotal,
                order && order._id,
                processResult,
                dispatch
            );
        }
    }, [ order, customer, user, name, email, phone, taxCert, orderToPay,
         pickupName, pickupPhone, pickupDate, cart, cartNotes, orderTotal,
         systemControls, dispatch ]
    );

    const holdOrder = ( order ) => {
        apiPayOrder( order._id, orderTotal, null, 'HOLD', null, null,
            ( result ) => {
                dispatch( returnToAdminAction() );
            },
            dispatch
        );
    }

    const placeHoldOrder = (e) => {
        createOrUpdateOrder( e, holdOrder );
        e.stopPropagation();
    }

    const showHoldConfirmDialog = (e) => {
        e.stopPropagation();
        setShowHoldConfirm( true );
    }

    const cancelHoldConfirm = (e) => {
        e.stopPropagation();
        setShowHoldConfirm( false );
    }

    const outOfStockItems = useCallback( () => cart.filter( 
        orderItem => outOfStock[ orderItem.variation.squareVariationId ] 
    ), [ cart, outOfStock ] );

    const startSplit = useCallback( ( e ) => {
        createOrUpdateOrder( e, () => {
            setShowSplitPaymentDialog( true );
        } );
    }, [ createOrUpdateOrder, setShowSplitPaymentDialog ] );

    const hideSplitPaymentDialog = useCallback( ( e ) => {
        e.stopPropagation();
        setShowSplitPaymentDialog( false );
    }, [ setShowSplitPaymentDialog ] );

    if ( ! systemControls ) {
        return null;
    }
    
    const your = user.isAdmin ? 'Customer\'s' : 'Enter your';

    return (
        <div className={ classes.Main } >
            <div className={ classes.Links } >
                { orderToPay ? <div className={ classes.ContinueShopping }>&nbsp;</div> :
                <React.Fragment>
                    <Link to={ user.isAdmin ? '/products' : '/' } className={ classes.ContinueShopping } 
                    >Continue Shopping</Link>
                    <Link to='/cart' className={ classes.Cart } >Cart</Link>
                </React.Fragment>
                }
            </div>

            <div className={ classes.Content } >
                { calendar && pickupDate &&
                    <div className={ classes.ClosingTime } >
                        <strong>NOTE: { user.isAdmin ? 'TELL THE CUSTOMER: ' : '' }</strong>
                        On your pickup date, { format( pickupDate, 'EEEE, MMM d' ) },
                        <strong> the store closes at { closingTime( pickupDate, calendar ) }</strong>.
                        You will not be able to pick up your order if you arrive
                        later than that.
                    </div>
                }
                <div className={ classes.CheckoutColumns } >
                    <div className={ classes.Spacer } >
                    { systemControls.inPerson
                        ? <CustomerList name={ name } phone={ phone }email={ email } 
                                selected={ customer } onSelect={ selectCustomer } 
                          />
                        : <span>&nbsp;</span>
                    }
                    </div>
                    <div>
                        <div className={ classes.ContactInfo } >
                            <div>{ your } contact details:</div>
                            <input type='text' value={ name } 
                                onChange={ (e) => setName( e.target.value ) } 
                                placeholder={ 'First-name Last-name' } />
                            { nameHint( name ) }
                            <input type='phone' value={ phone } 
                                onChange={ (e) => {
                                    setPhone( e.target.value ) 
                                    setUserError( null );
                                } }
                                placeholder={ `${ your } phone` } />
                            <input type='email' value={ email } 
                                onChange={ (e) => {
                                    setEmail( e.target.value );
                                    setUserError( null );
                                } }
                                placeholder={ `${ your } email` } />
                            { emailHint( name, phone, email ) }
                        </div>

                        <div className={ classes.ContactInfo } >
                            <div>
                                Enter contact details for the person picking up 
                                the order{ user.isAdmin ? ' if different' : <strong> if not you</strong> }:
                            </div>
                            <input type='text' value={ pickupName } 
                                onChange={ (e) => setPickupName( e.target.value ) } 
                                placeholder='Pickup first-name last-name' />
                            { nameHint( pickupName ) }
                            <input type='phone' value={ pickupPhone } 
                                onChange={ (e) => setPickupPhone( e.target.value ) } 
                                placeholder='Pickup phone no' />
                        </div>
                    </div>
                    <div className={ classes.Amounts } >
                        { user.isAdmin &&
                            <div className={ classes.TaxCert } >
                                <div className={ classes.Prompt } onClick={ showTaxCertInput } >
                                    { taxCert ? 'Change Tax Cert' : 'Tax Exempt?' }
                                </div> 
                                { taxCert &&
                                    <div className={ classes.TaxCertValue }>Tax certificate: { taxCert }</div> 
                                }
                            </div>
                        }
                        
                        { showTaxCert &&
                            <Modal onClick={ hideTaxCertInput } >
                                <div>Enter tax cert:</div>
                                <br />
                                <input id='taxCertInput' type='text' 
                                    onClick={ (e) => e.stopPropagation() }
                                    defaultValue={ taxCert } 
                                    placeholder='Tax Certificate' className={ classes.TaxCertInput }
                                    onInput={ processTaxCertEntry } ref={ taxCertInputRef }
                                />
                                <Button onClick={ acceptTaxCert } >Add Tax Cert</Button>
                                <Button onClick={ removeTaxCert } >Remove Tax Cert</Button>
                            </Modal>
                        }

                        {/* { user.isAdmin && discountOptions &&
                            <div className={ classes.DiscountButton } >
                                <div className={ classes.Prompt } onClick={ showDiscounts } >
                                    { selectedDiscount ? 'Change Discounts' : 'Apply Discounts' }
                                </div> 
                            </div>
                        }
                        
                        { showDiscountPopup &&
                            <Modal onClick={ hideDiscounts } >
                                <div>Select Discount:</div>
                                <br />
                                <span style={ { "font-weight": "bold", color: "white" } }>
                                    { discountOptions[ 0 ].label }
                                </span>
                                <Button onClick={ addDiscount } >Apply Discount</Button>
                                <Button onClick={ removeDiscount } >{ 
                                    selectedDiscount ? 'Remove Discount' : 'Cancel' 
                                }</Button>
                            </Modal>
                        } */}

                        <CartTotals 
                            cart={ cart } tipAmount={ tipAmount } taxCert={ taxCert }
                            setNoAmount={ setNoAmount }
                        />

                        <div className={ classes.Prompt } onClick={ showTipInput } >
                            { tipAmount ? 'Change Tip Amount' : 'Add Tip' }
                        </div>
                    </div>
                </div>
                { showTip &&
                    <Modal onClick={ hideTipInput } >
                        <div>Enter tip amount:</div>
                        <br />
                        <input id='tipInput' type='text' 
                            defaultValue={ orderItemUtils.formatDollarAmount( tipAmount ) } 
                            placeholder='Tip amount' className={ classes.TipInput }
                            onInput={ processTipEntry } ref={ tipInputRef }
                            onClick={ (e) => e.stopPropagation() }
                        />
                        <Button onClick={ acceptTipChanges } >Add Tip</Button>
                        <Button onClick={ removeTip } >Remove Tip</Button>
                    </Modal>
                }

                { ( ( messages.length > 0 ) || userError ) &&
                    <ul className={ classes.Messages } >
                        { userError &&
                            <li key={ userError } >{ userError }</li>
                        }
                        { messages.map( message =>
                            <li key={ message } >{ message }</li>
                        ) }
                    </ul>
                }

                { outOfStock ?
                    <Modal onClick={ returnToCart } >
                        <div>
                            Your order could not be completed. 
                            Some items went out of stock while you were shopping:
                        </div>
                        <br />
                        { outOfStockItems().map( orderItem =>
                            <div key={ orderItem.variation.squareVariationId } >
                                { orderItem.variation.displayName }
                                { orderItem.variation.squareItemName }
                            </div>
                        ) }
                        <Button onClick={ returnToCart } >OK</Button>
                    </Modal>
                : squareIds && messages.length === 0 && ! noAmount ?
                    <div className={ classes.PaymentButtons } >
                        <PaymentButtons
                            order={ order } setOrder={ setOrder }
                            createOrUpdateOrder={ createOrUpdateOrder } 
                            paymentTotal={ orderTotal } 
                            tipAmount={ tipAmount }
                            squareIds={ squareIds }
                            setSquareIds={ setSquareIds }
                            setBlockInput={ setBlockInput }
                        >
                            { user.isAdmin && ( ! order || order.squarePaymentId !== 'HOLD' ) &&
                                <Button onClick={ showHoldConfirmDialog } 
                                    className={ ' '/*classes.Disabled*/ }
                                    disabled={ tipAmount || ! name || ! phone }
                                >
                                    { ! name || ! phone ?
                                        'Need name & phone to hold' :
                                    tipAmount ? 'Remove tip to hold order' :
                                        'Hold for payment'
                                    }
                                </Button>
                            }

                            { user.isAdmin && partialPaymentItem && ! isPaid( order ) &&
                                <Button onClick={ startSplit } 
                                    className={ classes.SplitPaymentButton }
                                    disabled={ order && order.squarePaymentId && orderTotal < 200 }
                                >
                                    Split Payment
                                </Button>
                            }
                        </PaymentButtons>
                    </div>
                :
                    null
                }
            </div>

            { blockInput && <Modal noX showSpinner /> }

            { showHoldConfirm &&
                <Modal NoX>
                    <div onClick={ e => e.stopPropagation() } >
                        <div>
                            <div>Confirm that the order is to be held for later payment.</div>
                            <Button onClick={ placeHoldOrder } >Hold for payment</Button>
                            <Button onClick={ cancelHoldConfirm } >Cancel</Button>
                        </div>
                    </div>
                </Modal>
            }

            { showSplitPaymentDialog &&
                <SplitPaymentDialog
                    customerOrder={ order }
                    paymentTotal={ orderTotal + ( tipAmount || 0 ) }
                    squareIds={ squareIds }
                    setSquareIds={ setSquareIds }
                    onCancel={ hideSplitPaymentDialog }
                />
            }

            { ! systemControls?.ordersActive &&
                <Modal rounded onClick={ returnToCart } >
                    <div>
                        You cannot pay for this order at the moment.
                        <br />
                        Please try again in a couple of hours.
                    </div>
                    <Button onClick={ returnToCart } >OK</Button>
                </Modal>
            }

            <div className={ classes.FooterSpacer } />
            
            <div className={ classes.Footer } >
                <div className={ classes.FooterText } >Payments handled by Square</div>
                <div className={ classes.SquareLogo } > 
                    <img src='https://squareup.com/favicon.ico' alt='Square' />
                </div>
            </div>
        </div>
    );
}

export default withRouter( Checkout );